const styles = {
    nameHolder: {lineHeight: "18px", paddingBottom: "4px"},
    emailHolder: {margin: "10px 0"},
    locationIcon: {marginLeft: "-4px", fontSize: "20px"},
    stateHolder: {paddingLeft: "5px", lineHeight: "22px"},
    editButtonHolder: {marginTop: "auto"},
    addStripeButtonHolder: {marginTop: "10px"}
};

export {styles}